module.exports = __webpack_public_path__ + "static/img/file_comp.dbe6216.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ICON/file_comp.png
// module id = OAad
// module chunks = 4